export default {
    "name": "SearchItinerary",
    "kind": "HoudiniQuery",
    "hash": "17e87ebe314cdf4ef1781b15f731b3746464cfccb00fbef59f41a78a5d86291a",

    "raw": `query SearchItinerary($input: SearchItineraryInput!) {
  searchItinerary(input: $input) {
    ... on SearchItinerarySuccessResult {
      __typename
      departureAddress {
        city
        country {
          code
          name
        }
        department
        region
        zipCode
      }
      arrivalAddress {
        city
        country {
          code
          name
        }
        department
        region
        zipCode
      }
      type
      routes {
        identifier
        legDistances
        isEv
        types
        summary
        routeDistance {
          value
          unit
        }
        duration
        trafficImpactDuration
        geometry
        fuelConsumption
        electricityConsumption
        energyCost {
          amount
          currency
        }
        costs {
          fuel {
            amount
            currency
          }
          tolls {
            amount
            currency
          }
          vignette {
            amount
            currency
          }
          electricity {
            amount
            currency
          }
        }
        totalCost {
          amount
          currency
        }
        carbonDioxideEmission
        tolls {
          name
          cost {
            amount
            currency
          }
        }
        evData {
          initialChargeLevel
          finalChargeLevel
          rechargePoints {
            coordinates {
              lat
              lng
            }
            distance {
              value
              unit
            }
          }
        }
        lezMentions {
          message
          url
          urlName
        }
        tracking {
          distance
          distanceType
          highwayDistance
          type
        }
        highwayDistance {
          value
          unit
        }
        highwayDuration
        roadsWithoutHighwayDistance {
          value
          unit
        }
        roadsWithoutHighwayDuration
        trafficMentions {
          geometry
          color
        }
        scenicDistance {
          value
          unit
        }
      }
      waypoints {
        name
        location {
          lat
          lng
        }
        country
        city
      }
      advertisingPartners {
        ... on SearchAdvertisingPartnersSuccessResult {
          __typename
          boxMaps {
            type
            message
            url
            tracking
            img
          }
          cards {
            type
            content {
              ... on PartnerAdRichContent {
                adservingId
                priority
                type
                title
                description
                nextDescription
                legalNotice
                highlight {
                  text
                  color
                }
                nextHighlight {
                  text
                  color
                }
                brandImage {
                  w160
                  w320
                  w640
                  w960
                  w1280
                  w1920
                }
                contentImage {
                  w160
                  w320
                  w640
                  w960
                  w1280
                  w1920
                }
                styles {
                  titleColor {
                    r
                    g
                    b
                    o
                  }
                  descriptionColor {
                    r
                    g
                    b
                    o
                  }
                  backgroundColor {
                    r
                    g
                    b
                    o
                  }
                  contentImageAlignment
                }
                cta {
                  url
                  clickUrl
                  impressionUrl
                  label
                  styles {
                    foregroundColors {
                      enabled {
                        r
                        g
                        b
                        o
                      }
                      hover {
                        r
                        g
                        b
                        o
                      }
                      focus {
                        r
                        g
                        b
                        o
                      }
                      pressed {
                        r
                        g
                        b
                        o
                      }
                    }
                    backgroundColors {
                      enabled {
                        r
                        g
                        b
                        o
                      }
                      hover {
                        r
                        g
                        b
                        o
                      }
                      focus {
                        r
                        g
                        b
                        o
                      }
                      pressed {
                        r
                        g
                        b
                        o
                      }
                    }
                    shadowColor {
                      r
                      g
                      b
                      o
                    }
                    borderRadius
                  }
                }
              }
              ... on PartnerAdMediaContent {
                adservingId
                priority
                type
                image {
                  w160
                  w320
                  w640
                  w960
                  w1280
                  w1920
                }
                styles {
                  backgroundColor {
                    r
                    g
                    b
                    o
                  }
                }
                cta {
                  url
                  clickUrl
                  impressionUrl
                  label
                  styles {
                    foregroundColors {
                      enabled {
                        r
                        g
                        b
                        o
                      }
                      hover {
                        r
                        g
                        b
                        o
                      }
                      focus {
                        r
                        g
                        b
                        o
                      }
                      pressed {
                        r
                        g
                        b
                        o
                      }
                    }
                    backgroundColors {
                      enabled {
                        r
                        g
                        b
                        o
                      }
                      hover {
                        r
                        g
                        b
                        o
                      }
                      focus {
                        r
                        g
                        b
                        o
                      }
                      pressed {
                        r
                        g
                        b
                        o
                      }
                    }
                    shadowColor {
                      r
                      g
                      b
                      o
                    }
                    borderRadius
                  }
                }
              }
              __typename
            }
          }
        }
        ... on SearchAdvertisingPartnersNotFoundResult {
          __typename
          message
          type
        }
        __typename
      }
      itineraryResultForRoadsheet
      climateLawMessages {
        type
        text
        hashtag
      }
      arrivalZoi {
        zoiId
        name
        center {
          lng
          lat
        }
        radius
        polygon {
          type
          coordinates
        }
        images {
          ...ImageFragment
        }
        zoiImages {
          ...ImageFragment
        }
        containsEvStation
        description
      }
      adsTextLines {
        text
        ctaText
        ctaLink
        color
        advertiser
      }
      closingsMessage {
        text
      }
      departureCityPath
      arrivalCityPath
    }
    ... on SearchItineraryNotFoundResult {
      message
    }
    __typename
  }
}

fragment ImageFragment on Image {
  copyright
  w160
  w320
  w640
  w960
  w1280
  w1920
  __typename
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "searchItinerary": {
                "type": "SearchItineraryResult",
                "keyRaw": "searchItinerary(input: $input)",

                "selection": {
                    "abstractFields": {
                        "fields": {
                            "SearchItinerarySuccessResult": {
                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                },

                                "departureAddress": {
                                    "type": "Address",
                                    "keyRaw": "departureAddress",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "city": {
                                                "type": "String",
                                                "keyRaw": "city",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "country": {
                                                "type": "Country",
                                                "keyRaw": "country",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "code": {
                                                            "type": "String",
                                                            "keyRaw": "code",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "department": {
                                                "type": "String",
                                                "keyRaw": "department",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "region": {
                                                "type": "String",
                                                "keyRaw": "region",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "zipCode": {
                                                "type": "String",
                                                "keyRaw": "zipCode",
                                                "nullable": true,
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "arrivalAddress": {
                                    "type": "Address",
                                    "keyRaw": "arrivalAddress",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "city": {
                                                "type": "String",
                                                "keyRaw": "city",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "country": {
                                                "type": "Country",
                                                "keyRaw": "country",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "code": {
                                                            "type": "String",
                                                            "keyRaw": "code",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "department": {
                                                "type": "String",
                                                "keyRaw": "department",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "region": {
                                                "type": "String",
                                                "keyRaw": "region",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "zipCode": {
                                                "type": "String",
                                                "keyRaw": "zipCode",
                                                "nullable": true,
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "type": {
                                    "type": "SearchItineraryResultType",
                                    "keyRaw": "type",
                                    "visible": true
                                },

                                "routes": {
                                    "type": "Route",
                                    "keyRaw": "routes",

                                    "selection": {
                                        "fields": {
                                            "identifier": {
                                                "type": "String",
                                                "keyRaw": "identifier",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "legDistances": {
                                                "type": "Float",
                                                "keyRaw": "legDistances",
                                                "visible": true
                                            },

                                            "isEv": {
                                                "type": "Boolean",
                                                "keyRaw": "isEv",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "types": {
                                                "type": "RouteType",
                                                "keyRaw": "types",
                                                "visible": true
                                            },

                                            "summary": {
                                                "type": "String",
                                                "keyRaw": "summary",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "routeDistance": {
                                                "type": "Distance",
                                                "keyRaw": "routeDistance",

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "duration": {
                                                "type": "Int",
                                                "keyRaw": "duration",
                                                "visible": true
                                            },

                                            "trafficImpactDuration": {
                                                "type": "Int",
                                                "keyRaw": "trafficImpactDuration",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "geometry": {
                                                "type": "String",
                                                "keyRaw": "geometry",
                                                "visible": true
                                            },

                                            "fuelConsumption": {
                                                "type": "Float",
                                                "keyRaw": "fuelConsumption",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "electricityConsumption": {
                                                "type": "Float",
                                                "keyRaw": "electricityConsumption",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "energyCost": {
                                                "type": "Price",
                                                "keyRaw": "energyCost",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "amount": {
                                                            "type": "Float",
                                                            "keyRaw": "amount",
                                                            "visible": true
                                                        },

                                                        "currency": {
                                                            "type": "String",
                                                            "keyRaw": "currency",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "costs": {
                                                "type": "RouteCosts",
                                                "keyRaw": "costs",

                                                "selection": {
                                                    "fields": {
                                                        "fuel": {
                                                            "type": "Price",
                                                            "keyRaw": "fuel",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "tolls": {
                                                            "type": "Price",
                                                            "keyRaw": "tolls",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "vignette": {
                                                            "type": "Price",
                                                            "keyRaw": "vignette",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "electricity": {
                                                            "type": "Price",
                                                            "keyRaw": "electricity",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "totalCost": {
                                                "type": "Price",
                                                "keyRaw": "totalCost",

                                                "selection": {
                                                    "fields": {
                                                        "amount": {
                                                            "type": "Float",
                                                            "keyRaw": "amount",
                                                            "visible": true
                                                        },

                                                        "currency": {
                                                            "type": "String",
                                                            "keyRaw": "currency",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "carbonDioxideEmission": {
                                                "type": "Float",
                                                "keyRaw": "carbonDioxideEmission",
                                                "visible": true
                                            },

                                            "tolls": {
                                                "type": "RouteToll",
                                                "keyRaw": "tolls",

                                                "selection": {
                                                    "fields": {
                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "cost": {
                                                            "type": "Price",
                                                            "keyRaw": "cost",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "evData": {
                                                "type": "EvData",
                                                "keyRaw": "evData",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "initialChargeLevel": {
                                                            "type": "Float",
                                                            "keyRaw": "initialChargeLevel",
                                                            "visible": true
                                                        },

                                                        "finalChargeLevel": {
                                                            "type": "Float",
                                                            "keyRaw": "finalChargeLevel",
                                                            "visible": true
                                                        },

                                                        "rechargePoints": {
                                                            "type": "RechargePointData",
                                                            "keyRaw": "rechargePoints",

                                                            "selection": {
                                                                "fields": {
                                                                    "coordinates": {
                                                                        "type": "Coordinates",
                                                                        "keyRaw": "coordinates",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "lat": {
                                                                                    "type": "Float",
                                                                                    "keyRaw": "lat",
                                                                                    "visible": true
                                                                                },

                                                                                "lng": {
                                                                                    "type": "Float",
                                                                                    "keyRaw": "lng",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "distance": {
                                                                        "type": "Distance",
                                                                        "keyRaw": "distance",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "value": {
                                                                                    "type": "Float",
                                                                                    "keyRaw": "value",
                                                                                    "visible": true
                                                                                },

                                                                                "unit": {
                                                                                    "type": "DistanceUnit",
                                                                                    "keyRaw": "unit",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "lezMentions": {
                                                "type": "RestrictedZoneMention",
                                                "keyRaw": "lezMentions",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "message": {
                                                            "type": "String",
                                                            "keyRaw": "message",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "url": {
                                                            "type": "String",
                                                            "keyRaw": "url",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "urlName": {
                                                            "type": "String",
                                                            "keyRaw": "urlName",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "tracking": {
                                                "type": "TrackingData",
                                                "keyRaw": "tracking",

                                                "selection": {
                                                    "fields": {
                                                        "distance": {
                                                            "type": "Float",
                                                            "keyRaw": "distance",
                                                            "visible": true
                                                        },

                                                        "distanceType": {
                                                            "type": "String",
                                                            "keyRaw": "distanceType",
                                                            "visible": true
                                                        },

                                                        "highwayDistance": {
                                                            "type": "Float",
                                                            "keyRaw": "highwayDistance",
                                                            "visible": true
                                                        },

                                                        "type": {
                                                            "type": "Int",
                                                            "keyRaw": "type",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "highwayDistance": {
                                                "type": "Distance",
                                                "keyRaw": "highwayDistance",

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "highwayDuration": {
                                                "type": "Int",
                                                "keyRaw": "highwayDuration",
                                                "visible": true
                                            },

                                            "roadsWithoutHighwayDistance": {
                                                "type": "Distance",
                                                "keyRaw": "roadsWithoutHighwayDistance",

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "roadsWithoutHighwayDuration": {
                                                "type": "Int",
                                                "keyRaw": "roadsWithoutHighwayDuration",
                                                "visible": true
                                            },

                                            "trafficMentions": {
                                                "type": "RouteTrafficMention",
                                                "keyRaw": "trafficMentions",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "geometry": {
                                                            "type": "String",
                                                            "keyRaw": "geometry",
                                                            "visible": true
                                                        },

                                                        "color": {
                                                            "type": "RouteTrafficMentionColor",
                                                            "keyRaw": "color",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "scenicDistance": {
                                                "type": "Distance",
                                                "keyRaw": "scenicDistance",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "waypoints": {
                                    "type": "Waypoint",
                                    "keyRaw": "waypoints",

                                    "selection": {
                                        "fields": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "location": {
                                                "type": "Coordinates",
                                                "keyRaw": "location",

                                                "selection": {
                                                    "fields": {
                                                        "lat": {
                                                            "type": "Float",
                                                            "keyRaw": "lat",
                                                            "visible": true
                                                        },

                                                        "lng": {
                                                            "type": "Float",
                                                            "keyRaw": "lng",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "country": {
                                                "type": "String",
                                                "keyRaw": "country",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "city": {
                                                "type": "String",
                                                "keyRaw": "city",
                                                "nullable": true,
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "advertisingPartners": {
                                    "type": "SearchAdvertisingPartnersResult",
                                    "keyRaw": "advertisingPartners",

                                    "selection": {
                                        "abstractFields": {
                                            "fields": {
                                                "SearchAdvertisingPartnersSuccessResult": {
                                                    "__typename": {
                                                        "type": "String",
                                                        "keyRaw": "__typename",
                                                        "visible": true
                                                    },

                                                    "boxMaps": {
                                                        "type": "BoxMap",
                                                        "keyRaw": "boxMaps",

                                                        "selection": {
                                                            "fields": {
                                                                "type": {
                                                                    "type": "AdvertisingPartnerType",
                                                                    "keyRaw": "type",
                                                                    "visible": true
                                                                },

                                                                "message": {
                                                                    "type": "String",
                                                                    "keyRaw": "message",
                                                                    "visible": true
                                                                },

                                                                "url": {
                                                                    "type": "String",
                                                                    "keyRaw": "url",
                                                                    "visible": true
                                                                },

                                                                "tracking": {
                                                                    "type": "String",
                                                                    "keyRaw": "tracking",
                                                                    "nullable": true,
                                                                    "visible": true
                                                                },

                                                                "img": {
                                                                    "type": "String",
                                                                    "keyRaw": "img",
                                                                    "nullable": true,
                                                                    "visible": true
                                                                }
                                                            }
                                                        },

                                                        "visible": true
                                                    },

                                                    "cards": {
                                                        "type": "PartnerAd",
                                                        "keyRaw": "cards",

                                                        "selection": {
                                                            "fields": {
                                                                "type": {
                                                                    "type": "AdvertisingPartnerType",
                                                                    "keyRaw": "type",
                                                                    "visible": true
                                                                },

                                                                "content": {
                                                                    "type": "PartnerAdContent",
                                                                    "keyRaw": "content",

                                                                    "selection": {
                                                                        "abstractFields": {
                                                                            "fields": {
                                                                                "PartnerAdRichContent": {
                                                                                    "adservingId": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "adservingId",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "priority": {
                                                                                        "type": "Int",
                                                                                        "keyRaw": "priority",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "type": {
                                                                                        "type": "PartnerAdContentType",
                                                                                        "keyRaw": "type",
                                                                                        "visible": true
                                                                                    },

                                                                                    "title": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "title",
                                                                                        "visible": true
                                                                                    },

                                                                                    "description": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "description",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "nextDescription": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "nextDescription",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "legalNotice": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "legalNotice",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "highlight": {
                                                                                        "type": "Highlight",
                                                                                        "keyRaw": "highlight",
                                                                                        "nullable": true,

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "text": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "text",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "color": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "color",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "nextHighlight": {
                                                                                        "type": "Highlight",
                                                                                        "keyRaw": "nextHighlight",
                                                                                        "nullable": true,

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "text": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "text",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "color": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "color",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "brandImage": {
                                                                                        "type": "Image",
                                                                                        "keyRaw": "brandImage",

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "w160": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w160",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w320": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w320",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w640": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w640",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w960": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w960",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w1280": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w1280",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w1920": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w1920",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "contentImage": {
                                                                                        "type": "Image",
                                                                                        "keyRaw": "contentImage",
                                                                                        "nullable": true,

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "w160": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w160",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w320": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w320",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w640": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w640",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w960": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w960",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w1280": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w1280",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w1920": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w1920",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "styles": {
                                                                                        "type": "PartnersAdRichContentStyles",
                                                                                        "keyRaw": "styles",

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "titleColor": {
                                                                                                    "type": "Color",
                                                                                                    "keyRaw": "titleColor",

                                                                                                    "selection": {
                                                                                                        "fields": {
                                                                                                            "r": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "r",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "g": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "g",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "b": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "b",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "o": {
                                                                                                                "type": "Float",
                                                                                                                "keyRaw": "o",
                                                                                                                "visible": true
                                                                                                            }
                                                                                                        }
                                                                                                    },

                                                                                                    "visible": true
                                                                                                },

                                                                                                "descriptionColor": {
                                                                                                    "type": "Color",
                                                                                                    "keyRaw": "descriptionColor",

                                                                                                    "selection": {
                                                                                                        "fields": {
                                                                                                            "r": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "r",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "g": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "g",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "b": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "b",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "o": {
                                                                                                                "type": "Float",
                                                                                                                "keyRaw": "o",
                                                                                                                "visible": true
                                                                                                            }
                                                                                                        }
                                                                                                    },

                                                                                                    "visible": true
                                                                                                },

                                                                                                "backgroundColor": {
                                                                                                    "type": "Color",
                                                                                                    "keyRaw": "backgroundColor",

                                                                                                    "selection": {
                                                                                                        "fields": {
                                                                                                            "r": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "r",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "g": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "g",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "b": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "b",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "o": {
                                                                                                                "type": "Float",
                                                                                                                "keyRaw": "o",
                                                                                                                "visible": true
                                                                                                            }
                                                                                                        }
                                                                                                    },

                                                                                                    "visible": true
                                                                                                },

                                                                                                "contentImageAlignment": {
                                                                                                    "type": "ImageAlignment",
                                                                                                    "keyRaw": "contentImageAlignment",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "cta": {
                                                                                        "type": "PartnersAdCta",
                                                                                        "keyRaw": "cta",

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "url": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "url",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "clickUrl": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "clickUrl",
                                                                                                    "nullable": true,
                                                                                                    "visible": true
                                                                                                },

                                                                                                "impressionUrl": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "impressionUrl",
                                                                                                    "nullable": true,
                                                                                                    "visible": true
                                                                                                },

                                                                                                "label": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "label",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "styles": {
                                                                                                    "type": "PartnersAdCtaStyles",
                                                                                                    "keyRaw": "styles",

                                                                                                    "selection": {
                                                                                                        "fields": {
                                                                                                            "foregroundColors": {
                                                                                                                "type": "PartnersAdColors",
                                                                                                                "keyRaw": "foregroundColors",

                                                                                                                "selection": {
                                                                                                                    "fields": {
                                                                                                                        "enabled": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "enabled",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "hover": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "hover",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "focus": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "focus",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "pressed": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "pressed",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        }
                                                                                                                    }
                                                                                                                },

                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "backgroundColors": {
                                                                                                                "type": "PartnersAdColors",
                                                                                                                "keyRaw": "backgroundColors",

                                                                                                                "selection": {
                                                                                                                    "fields": {
                                                                                                                        "enabled": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "enabled",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "hover": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "hover",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "focus": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "focus",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "pressed": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "pressed",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        }
                                                                                                                    }
                                                                                                                },

                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "shadowColor": {
                                                                                                                "type": "Color",
                                                                                                                "keyRaw": "shadowColor",

                                                                                                                "selection": {
                                                                                                                    "fields": {
                                                                                                                        "r": {
                                                                                                                            "type": "Int",
                                                                                                                            "keyRaw": "r",
                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "g": {
                                                                                                                            "type": "Int",
                                                                                                                            "keyRaw": "g",
                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "b": {
                                                                                                                            "type": "Int",
                                                                                                                            "keyRaw": "b",
                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "o": {
                                                                                                                            "type": "Float",
                                                                                                                            "keyRaw": "o",
                                                                                                                            "visible": true
                                                                                                                        }
                                                                                                                    }
                                                                                                                },

                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "borderRadius": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "borderRadius",
                                                                                                                "visible": true
                                                                                                            }
                                                                                                        }
                                                                                                    },

                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "__typename": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "__typename",
                                                                                        "visible": true
                                                                                    }
                                                                                },

                                                                                "PartnerAdMediaContent": {
                                                                                    "adservingId": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "adservingId",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "priority": {
                                                                                        "type": "Int",
                                                                                        "keyRaw": "priority",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "type": {
                                                                                        "type": "PartnerAdContentType",
                                                                                        "keyRaw": "type",
                                                                                        "visible": true
                                                                                    },

                                                                                    "image": {
                                                                                        "type": "Image",
                                                                                        "keyRaw": "image",

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "w160": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w160",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w320": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w320",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w640": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w640",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w960": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w960",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w1280": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w1280",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "w1920": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "w1920",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "styles": {
                                                                                        "type": "PartnersAdBaseStyles",
                                                                                        "keyRaw": "styles",

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "backgroundColor": {
                                                                                                    "type": "Color",
                                                                                                    "keyRaw": "backgroundColor",

                                                                                                    "selection": {
                                                                                                        "fields": {
                                                                                                            "r": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "r",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "g": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "g",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "b": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "b",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "o": {
                                                                                                                "type": "Float",
                                                                                                                "keyRaw": "o",
                                                                                                                "visible": true
                                                                                                            }
                                                                                                        }
                                                                                                    },

                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "cta": {
                                                                                        "type": "PartnersAdCta",
                                                                                        "keyRaw": "cta",

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "url": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "url",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "clickUrl": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "clickUrl",
                                                                                                    "nullable": true,
                                                                                                    "visible": true
                                                                                                },

                                                                                                "impressionUrl": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "impressionUrl",
                                                                                                    "nullable": true,
                                                                                                    "visible": true
                                                                                                },

                                                                                                "label": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "label",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "styles": {
                                                                                                    "type": "PartnersAdCtaStyles",
                                                                                                    "keyRaw": "styles",

                                                                                                    "selection": {
                                                                                                        "fields": {
                                                                                                            "foregroundColors": {
                                                                                                                "type": "PartnersAdColors",
                                                                                                                "keyRaw": "foregroundColors",

                                                                                                                "selection": {
                                                                                                                    "fields": {
                                                                                                                        "enabled": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "enabled",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "hover": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "hover",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "focus": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "focus",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "pressed": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "pressed",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        }
                                                                                                                    }
                                                                                                                },

                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "backgroundColors": {
                                                                                                                "type": "PartnersAdColors",
                                                                                                                "keyRaw": "backgroundColors",

                                                                                                                "selection": {
                                                                                                                    "fields": {
                                                                                                                        "enabled": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "enabled",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "hover": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "hover",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "focus": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "focus",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "pressed": {
                                                                                                                            "type": "Color",
                                                                                                                            "keyRaw": "pressed",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "r": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "r",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "g": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "g",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "b": {
                                                                                                                                        "type": "Int",
                                                                                                                                        "keyRaw": "b",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "o": {
                                                                                                                                        "type": "Float",
                                                                                                                                        "keyRaw": "o",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        }
                                                                                                                    }
                                                                                                                },

                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "shadowColor": {
                                                                                                                "type": "Color",
                                                                                                                "keyRaw": "shadowColor",

                                                                                                                "selection": {
                                                                                                                    "fields": {
                                                                                                                        "r": {
                                                                                                                            "type": "Int",
                                                                                                                            "keyRaw": "r",
                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "g": {
                                                                                                                            "type": "Int",
                                                                                                                            "keyRaw": "g",
                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "b": {
                                                                                                                            "type": "Int",
                                                                                                                            "keyRaw": "b",
                                                                                                                            "visible": true
                                                                                                                        },

                                                                                                                        "o": {
                                                                                                                            "type": "Float",
                                                                                                                            "keyRaw": "o",
                                                                                                                            "visible": true
                                                                                                                        }
                                                                                                                    }
                                                                                                                },

                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "borderRadius": {
                                                                                                                "type": "Int",
                                                                                                                "keyRaw": "borderRadius",
                                                                                                                "visible": true
                                                                                                            }
                                                                                                        }
                                                                                                    },

                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "__typename": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "__typename",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "typeMap": {}
                                                                        },

                                                                        "fields": {
                                                                            "__typename": {
                                                                                "type": "String",
                                                                                "keyRaw": "__typename",
                                                                                "visible": true
                                                                            }
                                                                        }
                                                                    },

                                                                    "abstract": true,
                                                                    "visible": true
                                                                }
                                                            }
                                                        },

                                                        "visible": true
                                                    }
                                                },

                                                "SearchAdvertisingPartnersNotFoundResult": {
                                                    "__typename": {
                                                        "type": "String",
                                                        "keyRaw": "__typename",
                                                        "visible": true
                                                    },

                                                    "message": {
                                                        "type": "String",
                                                        "keyRaw": "message",
                                                        "visible": true
                                                    },

                                                    "type": {
                                                        "type": "SearchAdvertisingPartnersResultType",
                                                        "keyRaw": "type",
                                                        "visible": true
                                                    }
                                                }
                                            },

                                            "typeMap": {}
                                        },

                                        "fields": {
                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "abstract": true,
                                    "visible": true
                                },

                                "itineraryResultForRoadsheet": {
                                    "type": "String",
                                    "keyRaw": "itineraryResultForRoadsheet",
                                    "visible": true
                                },

                                "climateLawMessages": {
                                    "type": "ClimateLawMessage",
                                    "keyRaw": "climateLawMessages",

                                    "selection": {
                                        "fields": {
                                            "type": {
                                                "type": "ClimateLawType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "text": {
                                                "type": "String",
                                                "keyRaw": "text",
                                                "visible": true
                                            },

                                            "hashtag": {
                                                "type": "String",
                                                "keyRaw": "hashtag",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "arrivalZoi": {
                                    "type": "Zoi",
                                    "keyRaw": "arrivalZoi",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "zoiId": {
                                                "type": "String",
                                                "keyRaw": "zoiId",
                                                "visible": true
                                            },

                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "visible": true
                                            },

                                            "center": {
                                                "type": "Coordinates",
                                                "keyRaw": "center",

                                                "selection": {
                                                    "fields": {
                                                        "lng": {
                                                            "type": "Float",
                                                            "keyRaw": "lng",
                                                            "visible": true
                                                        },

                                                        "lat": {
                                                            "type": "Float",
                                                            "keyRaw": "lat",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "radius": {
                                                "type": "Float",
                                                "keyRaw": "radius",
                                                "visible": true
                                            },

                                            "polygon": {
                                                "type": "Polygon",
                                                "keyRaw": "polygon",

                                                "selection": {
                                                    "fields": {
                                                        "type": {
                                                            "type": "String",
                                                            "keyRaw": "type",
                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Float",
                                                            "keyRaw": "coordinates",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "images": {
                                                "type": "Image",
                                                "keyRaw": "images",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "copyright": {
                                                            "type": "String",
                                                            "keyRaw": "copyright",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "w160": {
                                                            "type": "String",
                                                            "keyRaw": "w160",
                                                            "visible": true
                                                        },

                                                        "w320": {
                                                            "type": "String",
                                                            "keyRaw": "w320",
                                                            "visible": true
                                                        },

                                                        "w640": {
                                                            "type": "String",
                                                            "keyRaw": "w640",
                                                            "visible": true
                                                        },

                                                        "w960": {
                                                            "type": "String",
                                                            "keyRaw": "w960",
                                                            "visible": true
                                                        },

                                                        "w1280": {
                                                            "type": "String",
                                                            "keyRaw": "w1280",
                                                            "visible": true
                                                        },

                                                        "w1920": {
                                                            "type": "String",
                                                            "keyRaw": "w1920",
                                                            "visible": true
                                                        },

                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        }
                                                    },

                                                    "fragments": {
                                                        "ImageFragment": {
                                                            "arguments": {}
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "zoiImages": {
                                                "type": "Image",
                                                "keyRaw": "zoiImages",

                                                "selection": {
                                                    "fields": {
                                                        "copyright": {
                                                            "type": "String",
                                                            "keyRaw": "copyright",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "w160": {
                                                            "type": "String",
                                                            "keyRaw": "w160",
                                                            "visible": true
                                                        },

                                                        "w320": {
                                                            "type": "String",
                                                            "keyRaw": "w320",
                                                            "visible": true
                                                        },

                                                        "w640": {
                                                            "type": "String",
                                                            "keyRaw": "w640",
                                                            "visible": true
                                                        },

                                                        "w960": {
                                                            "type": "String",
                                                            "keyRaw": "w960",
                                                            "visible": true
                                                        },

                                                        "w1280": {
                                                            "type": "String",
                                                            "keyRaw": "w1280",
                                                            "visible": true
                                                        },

                                                        "w1920": {
                                                            "type": "String",
                                                            "keyRaw": "w1920",
                                                            "visible": true
                                                        },

                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        }
                                                    },

                                                    "fragments": {
                                                        "ImageFragment": {
                                                            "arguments": {}
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "containsEvStation": {
                                                "type": "Boolean",
                                                "keyRaw": "containsEvStation",
                                                "visible": true
                                            },

                                            "description": {
                                                "type": "String",
                                                "keyRaw": "description",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "adsTextLines": {
                                    "type": "AdsTextLine",
                                    "keyRaw": "adsTextLines",

                                    "selection": {
                                        "fields": {
                                            "text": {
                                                "type": "String",
                                                "keyRaw": "text",
                                                "visible": true
                                            },

                                            "ctaText": {
                                                "type": "String",
                                                "keyRaw": "ctaText",
                                                "visible": true
                                            },

                                            "ctaLink": {
                                                "type": "String",
                                                "keyRaw": "ctaLink",
                                                "visible": true
                                            },

                                            "color": {
                                                "type": "String",
                                                "keyRaw": "color",
                                                "visible": true
                                            },

                                            "advertiser": {
                                                "type": "String",
                                                "keyRaw": "advertiser",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "closingsMessage": {
                                    "type": "ClosingsMessage",
                                    "keyRaw": "closingsMessage",

                                    "selection": {
                                        "fields": {
                                            "text": {
                                                "type": "String",
                                                "keyRaw": "text",
                                                "nullable": true,
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "departureCityPath": {
                                    "type": "String",
                                    "keyRaw": "departureCityPath",
                                    "nullable": true,
                                    "visible": true
                                },

                                "arrivalCityPath": {
                                    "type": "String",
                                    "keyRaw": "arrivalCityPath",
                                    "nullable": true,
                                    "visible": true
                                }
                            },

                            "SearchItineraryNotFoundResult": {
                                "message": {
                                    "type": "String",
                                    "keyRaw": "message",
                                    "visible": true
                                },

                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                }
                            }
                        },

                        "typeMap": {}
                    },

                    "fields": {
                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        }
                    }
                },

                "abstract": true,
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "SearchItineraryInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            },

            "SearchItineraryInput": {
                "arrivalName": "String",
                "carId": "String",
                "constraint": "ItineraryConstraint",
                "coordinates": "CoordinatesInput",
                "currency": "Currency",
                "departureName": "String",
                "device": "Device",
                "distanceSystem": "DistanceSystem",
                "energyCost": "Float",
                "initialChargeLevel": "Float",
                "mode": "ItineraryTravelMode",
                "rechargeTreshold": "Float",
                "traffic": "ItineraryTrafficMode",
                "withCaravan": "Boolean",
                "withElectricVehicle": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=9b0ac1965e7593507d22a7c94e0f298bb3be7ea3486cf7b17339307f2eeeecab";